import { render, staticRenderFns } from "./liveList.vue?vue&type=template&id=61bb0e29&scoped=true&"
import script from "./liveList.vue?vue&type=script&lang=js&"
export * from "./liveList.vue?vue&type=script&lang=js&"
import style0 from "./liveList.vue?vue&type=style&index=0&id=61bb0e29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb0e29",
  null
  
)

export default component.exports